const baseUrl = process.env.CLIENT_API_URL || 'http://localhost:8006/api';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

async function tryFetch(route, options) {
  const res = await fetch(baseUrl + route, options);
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body.message);
  }
  return body;
}

export async function login(token) {
  const req = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify({}),
  };

  try {
    return await tryFetch('/auth/login/admin', req);
  } catch (err) {
    console.error('Failed to log in', err);
    return null;
  }
}

export function getCompanies() {
  return fetch(`${baseUrl}/getAllCompaniesAndProperties`)
    .then(r => r.json())
    .then(json => json.result)
    .catch(err => {
      console.error('fail:getCompanies', err);
      return null;
    });
}

export async function getAllUsers(token) {
  return tryFetch('/users', {
    method: 'GET',
    headers: {
      ...jsonHeaders,
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function deleteUser(userId, token) {
  const res = await fetch(`${baseUrl}/users/${userId}`, {
    method: 'DELETE',
    headers: {
      ...jsonHeaders,
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error((await res.json()).message);
  }

  return res;
}

export async function createUser(user, token) {
  return tryFetch('/users', {
    method: 'POST',
    headers: {
      ...jsonHeaders,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(user),
  });
}

export async function updateUser({ id, ...user }, token) {
  const res = await fetch(`${baseUrl}/users/${id}`, {
    method: 'PUT',
    headers: {
      ...jsonHeaders,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(user),
  });

  if (!res.ok) {
    throw new Error((await res.json()).message);
  }

  return res;
}
